import { InputNumber } from '@seiue/ui'
import { InputNumberProps } from 'antd'
import React from 'react'
import styled from 'styled-components'

import { NumberRangeValue } from './types'

export const NumberRange: React.FC<
  Omit<InputNumberProps<number>, 'value' | 'onChange'> & {
    value?: NumberRangeValue
    onChange?: (v: NumberRangeValue) => void
    id: string
  }
> = ({ value, onChange, id, ...rest }) => {
  const { egt, elt } = value || {}
  return (
    <Wrapper>
      <InputNumber
        {...rest}
        value={egt}
        onChange={(v) => {
          onChange && onChange({ egt: v, elt })
        }}
        placeholder="最小值"
        id={id}
      />
      <Sign>~</Sign>
      <InputNumber
        value={elt}
        onChange={(v) => {
          onChange && onChange({ egt, elt: v })
        }}
        placeholder="最大值"
        {...rest}
      />
    </Wrapper>
  )
}

const Wrapper = styled.div`
  &&& {
    .ant-input-number {
      width: 45%;
    }
  }
`

const Sign = styled.span`
  display: inline-block;
  width: 10%;
  text-align: center;
  color: ${(props) => props.theme.text._4};
`
